import React from 'react';
import CustomTable from '../../components/CustomTable';
import {globales, funciones } from '../../global';
import AuthService            from '../../AuthService';
import Request from 'superagent';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core/styles';
import {Table} from '@devexpress/dx-react-grid-material-ui';
import IconButton from '@material-ui/core/IconButton';
import ListAltIcon from '@material-ui/icons/ListAlt';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent          from '@material-ui/core/DialogContent';
import Box from '@material-ui/core/Box';
import CheckIcon from '@material-ui/icons/Check';
import {IntegratedFiltering} from '@devexpress/dx-react-grid';
import Backdrop from '@material-ui/core/Backdrop';

let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const styles = theme => ({

paper: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '520px' : undefined, 
  maxWidth: !movil ? '520px' : undefined,
  minHeight: !movil ? '520px' : undefined, 
  maxHeight: !movil ? '520px' : undefined
  }, 
paperConfirmation: { 
  borderRadius: globales.border_dialog,
  minWidth: '320px', 
  maxWidth: '320px', 
},	
paperTitle: { 
  height: '40px', 
  textAlign: 'center',
  verticalAlign: 'middle',
  lineHeight: '40px',
  margin: "1px " + globales.tabla.marginright + "px 0px " + globales.tabla.marginleft + "px", 
},
divSecondary: {
  marginBottom: '10px'
},
closeButton: {
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
},
backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},   
});
const widthTable = !movil ? window.screen.width - (globales.tabla.marginleft + globales.tabla.marginright) : 1336;
const columns =  [  
    { name: 'ID_SECCION', title: 'ID_SECCION'  },
    { name: 'CODIGO_CURSO', title: 'Código' },
    { name: 'DESCRIPCION_CURSO', title: 'Descripción' },
    { name: 'SECCION', title: 'Sección' },
    { name: 'MODALIDAD', title: 'Grupo' },
    { name: 'JORNADA', title: 'Jornada' },
    { name: 'AULA', title: 'Aula' },      
    { name: 'DIAS', title: 'Dias' },
    { name: 'INICIO', title: 'Desde' }, 
    { name: 'FIN', title: 'Hasta' }, 
 ];
const columnExtensions = [
    { columnName: 'CODIGO_CURSO', width: widthTable * 0.08 },
    { columnName: 'DESCRIPCION_CURSO', width: widthTable * 0.23 },
    { columnName: 'SECCION', width: widthTable * 0.08, align: 'center'},
    { columnName: 'MODALIDAD', width: widthTable * 0.10, align: 'center'},
    { columnName: 'JORNADA', width: widthTable * 0.10, align: 'center' }, 
    { columnName: 'AULA', width: widthTable * 0.07, align: 'center'},
    { columnName: 'DIAS', width: widthTable * 0.07, align: 'center'},
    { columnName: 'INICIO', width: widthTable * 0.07, align: 'center'}, 
    { columnName: 'FIN', width: widthTable * 0.07, align: 'center'},  
    { columnName: 'ID_SECCION', width: 0},
    { columnName: 'ESTATUS', width: 0},               
 ];
const columnsInfo= [
  { name: 'ID_POND_CATEDRATICO', title: 'ID_POND_CATEDRATICO'},
  { name: 'DESCRIPCION_PONDERACION', title: 'Ponderación'},
  { name: 'VALOR', title: 'Valor'},
  { name: 'EXTRAORDINARIO', title: 'Extraordinario'},
];
const columnExtensionsInfo = [
  { columnName: 'DESCRIPCION_PONDERACION', width: movil ? 160 : undefined, align: 'center' },   
  { columnName: 'VALOR', width: movil ? 160 : undefined, align: 'center' },      
  { columnName: 'EXTRAORDINARIO', width: movil ? 160 : undefined, align: 'center'}
];

const settingFilter = [
  { columnName: 'INICIO',
     predicate: (value, filter, row) => {
                value = value !== null ? funciones.getTime(value, 1) : value; 
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'FIN',
     predicate: (value, filter, row) => {
                value = value !== null ? funciones.getTime(value, 1) : value; 
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
];

const RowId = row => row.ID_SECCION;
const VirtualTable_cellComponent = (props) => {  
        
 if (props.column.name === 'INICIO')
 {    
    return ( <Table.Cell {...props}>
             { props.row.INICIO !== null ? funciones.getTime(props.row.INICIO, 1) : props.row.INICIO}
            </Table.Cell>);
 }
      
 if (props.column.name === 'FIN')
 {
          
   return ( <Table.Cell  {...props}>
            { props.row.FIN !== null  ? funciones.getTime(props.row.FIN, 1) : props.row.FIN }
            </Table.Cell>);
          
  }
   
  return (<Table.Cell {...props}/>);
      
}     
const TableSelectionCellComponent = (idRowSelected, handleClick) => (props) =>{
  
    if (props.row.ID_SECCION === idRowSelected)
    {
      return(
         <Table.StubCell>
            <Tooltip title="Ponderaciones">              
                <IconButton onClick={handleClick} style={{ marginLeft: 2 }} size="small">
                <ListAltIcon color="primary" />
                </IconButton>  
              </Tooltip> 
         </ Table.StubCell>
      );
    }
      
    return (<Table.StubCell />);
  
}
const VirtualTable_cellComponentInfo = ({value, ...props}) => {    
  
  if (props.column.name === 'EXTRAORDINARIO' && props.row.EXTRAORDINARIO === 1)
  {        
    return ( <Table.Cell style={{ paddingTop: 0, paddingBottom: 0 }} {...props}>
              <CheckIcon color="primary" />
             </Table.Cell>);
  }
            
  return (<Table.Cell value={props.column.name === 'EXTRAORDINARIO' ? null : value} {...props}/>);
       
}  

export default withStyles(styles) ( 
class App extends React.Component {

tablaRef = React.createRef();
vtRef = React.createRef();
dialogActionRef = React.createRef();
tablaInfoRef = React.createRef();

  constructor (props) {
    super(props);
    this.l=props.l
    this.e=props.e
    this.i=props.i
    this.state = {
       isLoggin : undefined,
       heightTableMain: 0,
       loadingMain: true,
       rows: [],
       idRowSelected: null,
       tooltipText: "",
       openModal: false,
       rowsInfo: [],
       heightTableInfo: 0,
       loadingInfo: false,
   };
  this.botones = [
    {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleClose, display:'auto', color: 'red'},  
   ];
}

handleRowClick = (idRow) => event => {
    this.setState({ idRowSelected: idRow });
}

handleClick = ()=>{
  
const infoRowSelected = this.state.rows.find(x => x.ID_SECCION === this.state.idRowSelected);

this.setState({ loadingInfo: true,
                rowsInfo: [],
                titleModal: infoRowSelected.DESCRIPCION_CURSO,
                openModal: true });
}

handleClose = ()=>{
 this.setState({ openModal: false });
}

onEntering = ()=>{

this.setState({ heightTableInfo: funciones.getHeightTableDialog(movil, this.tablaInfoRef, this.dialogActionRef, !movil ? 7 : 5) }, ()=>{

 new Request
 .get(`${globales.ip}/ponderacion_catedratico/secciones/ponderacion/${this.state.idRowSelected}/${tokenInfo.user}`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .retry(1)
 .timeout({ response: 15000, deadline: 20000, })
 .end((err, res) => {
         
    if (err) { 
 
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
             
         window.location.reload();
         return;
               
       }
       
       this.setState({ loadingInfo: false }, ()=>{
        funciones.showToast('e', 'No hay conexión');
       });
   
       return;
    }
       
    const rows = JSON.parse(res.text);
 
    this.setState({ rowsInfo: rows, 
                    loadingInfo: false });
               
  });

});

if (movil)
 {
  window.addEventListener("resize", this.onResize);   
 }

}

onResize = ()=> { 
if (this.tablaInfoRef.current !== null && this.dialogActionRef.current !== null)
this.setState({ heightTableInfo: funciones.getHeightTableDialog(movil, this.tablaInfoRef, this.dialogActionRef, 5) });  
}

obtener_secciones = ()=>{

  new Request
  .get(`${globales.ip}/ponderacion_catedratico/secciones/${tokenInfo.user}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 10000, }) 
  .end((err, res) => {
          
      if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                  
        }
          
        this.setState({ loadingMain: false }, ()=>{ 
          funciones.showToast('e', 'No hay conexión');
        });
                                              
        return;
      }
          
      const rows = JSON.parse(res.text);
      
      this.setState({ tooltipText: rows.length > 0 ? rows[0].TITULO : "", 
                      rows, 
                      loadingMain: false });
                
  });

}

componentDidMount() { 
   
  tokenInfo = Auth.getProfile(); //Token decodificado  
    
  this.setState({ isLoggin: tokenInfo.plataforma !== undefined ? true : false }, ()=>{

    if (tokenInfo.plataforma === 3){ //Usuario catedratico
      this.obtener_secciones();
    } 
        
    this.setState({ heightTableMain: funciones.getHeightTableMain(movil, this).heightTable }); 
    
  }); 
       
}

render() {
const { classes } = this.props;

  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
      <Paper className="Paper-main" square>
          {
            (() => {

            if (tokenInfo.plataforma === 3) //Si es Usuario Catedratico
             {
              
              return (
                <React.Fragment>
                 <Paper variant="outlined" className={classes.paperTitle}>
                 <Tooltip title={this.state.tooltipText}>
                  <Typography component='span' variant="h6" className="disableTouchOptions">
                    <strong>Secciones del período</strong>
                  </Typography>
                  </Tooltip>
                </Paper>
                 <div className={classes.divSecondary}/>
                 <div ref={this.tablaRef} style={{ marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil, }} className="disableTouchOptions">
                  <CustomTable 
                    Columns={columns} 
                    Rows={this.state.rows}                     
                    TableColumnExtensions={columnExtensions} 
                    columnWidths={columnExtensions}
                    DefaultHiddenColumnNames={['ID_SECCION', 'ESTATUS']}
                    getRowId={RowId}
                    VirtualTable_cellComponent={VirtualTable_cellComponent}
                    height = {this.state.heightTableMain} 
                    loading= {this.state.loadingMain} 
                    rowSelected={this.state.idRowSelected}
                    rowClick={this.handleRowClick}
                    enabledFilterRows 
                    showSelectionColumn
                    tableSelectionCellComponent={TableSelectionCellComponent(this.state.idRowSelected, this.handleClick)}
                    FilteringColumnExtensions={settingFilter}
                  />                  
                </div>   
                <Dialog open= {this.state.openModal}                            
                        TransitionProps={{ onEntering: this.onEntering }} 
                        classes = {{ paper: classes.paper }}
                        fullScreen = {movil}
                    >
                 <DialogTitle><Typography component='span' variant='subtitle2'><Box lineHeight={1} m={1}>{this.state.titleModal}</Box></Typography>
                  <IconButton className={classes.closeButton} onClick={this.handleClose} size="small">
                   <CloseIcon fontSize="small"/>
                  </IconButton>
                 </DialogTitle>
                 <DialogContent style = {{ paddingBottom: !movil ? '0px' : '5px' }}>
                  <div ref={this.tablaInfoRef} className="disableTouchOptions">
                    <CustomTable 
                      Columns={columnsInfo} 
                      Rows={this.state.rowsInfo}                     
                      TableColumnExtensions={columnExtensionsInfo} 
                      DefaultHiddenColumnNames={['ID_POND_CATEDRATICO']}
                      VirtualTable_cellComponent={VirtualTable_cellComponentInfo}
                      height={this.state.heightTableInfo} 
                      loading={this.state.loadingInfo}                    
                    />                  
                  </div> 
                  </DialogContent>
                  <DialogActions ref={this.dialogActionRef} />
                </Dialog>

                <Backdrop open={this.state.loadingMain || this.state.loadingInfo} 
                          className={classes.backdrop} 
                          invisible 
                          transitionDuration={0}/>

                </React.Fragment>
              );

             }             
             
            })()            
          }          
        </Paper>
      </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)
